module.exports = __webpack_public_path__ + "static/media/de02.d98d9955.jpg";